import * as model from './model.js';
import { MODAL_CLOSE_SEC } from './config.js';
// import { render } from 'sass';
import searchView from './views/searchView.js';
import recipeView from './views/recipeView.js';
import resultsView from './views/resultsView.js';
import paginationView from './views/pagination.js';
import bookmarksView from './views/bookmarksView.js';
import addRecipeView from './views/addRecipeView.js';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
// import icons from 'url:../img/icons.svg';

// https://forkify-api.herokuapp.com/v2
///////////////////////////////////////
// if (module.hot) {module.hot.accept();}

const controlRecipes = async function () {
  try {
    const id = window.location.hash.slice(1);
    if (!id) return;
    recipeView.renderSpinner();
    // UPDATE RESULTS VIEW TO MARK SELECTED SEARCH RESULTS
    resultsView.update(model.getSearchResultsPage());
    // UPDATING BOOKMARKS VIEW
    bookmarksView.update(model.state.bookmarks);
    //  LOADING RECIPE
    await model.loadRecipe(id);
    const { recipe } = model.state;
    //  RENDERING RECIPE
    recipeView.render(model.state.recipe);
  } catch (err) {
    recipeView.renderError();
  }
};
const controlSearchResults = async function () {
  try {
    resultsView.renderSpinner();
    // GET SEARCH QUERY
    const query = searchView.getQuery();
    if (!query) return;
    // LOAD SEARCH
    await model.loadSearchResults(query);
    // RENDER RESULTS
    // resultsView.render(model.state.search.results);
    resultsView.render(model.getSearchResultsPage());
    // RENDER PAGINATION
    paginationView.render(model.state.search);
  } catch (err) {
    console.log(err);
  }
};
const controlPagination = function (goToPage) {
  // RENDER NEW RESULTS

  resultsView.render(model.getSearchResultsPage(goToPage));

  // RENDER NEW PAGINATION BUTTONS

  paginationView.render(model.state.search);
};
const controlServings = function (newServings) {
  // UPDATE SERVINGS
  model.updateServings(newServings);

  // UPDATE VIEW
  // recipeView.render(model.state.recipe);
  recipeView.update(model.state.recipe);
};
const controlAddBookmark = function () {
  // ADD/REMOVE BOOKMARK
  if (!model.state.recipe.bookmarked) model.addBookMark(model.state.recipe);
  else model.deleteBookmark(model.state.recipe.id);
  // UPDATE RECIPE VIEW
  recipeView.update(model.state.recipe);
  // RENDER BOOKMARKS
  bookmarksView.render(model.state.bookmarks);
};
const controlBookmarks = function () {
  bookmarksView.render(model.state.bookmarks);
};

const controlAddRecipe = async function (newRecipe) {
  try {
    // SPINNER
    addRecipeView.renderSpinner();

    // ADD NEW RECIPE
    await model.uploadRecipe(newRecipe);
    console.log(model.state.recipe);
    // RENDER STATE
    recipeView.render(model.state.recipe);
    // SUCCESS MESSAGE
    addRecipeView.rendeerMessage();
    // RENDER BOOKMARK VIEW
    bookmarksView.render(model.state.bookmarks);

    // CHANGE ID IN THE URL
    window.history.pushState(null, '', `#${model.state.recipe.id}`);

    // CLOSE FORM
    setTimeout(function () {
      addRecipeView.toggleWindow();
    }, MODAL_CLOSE_SEC * 1000);
  } catch (err) {
    console.log(err);
    addRecipeView.renderError(err.message);
  }
};
const init = function () {
  bookmarksView.addHandlerRender(controlBookmarks);
  recipeView.addHandlerRender(controlRecipes);
  recipeView.addHandlerUpdateServings(controlServings);
  recipeView.addHandlerAddBookmark(controlAddBookmark);
  searchView.addHandlerSearch(controlSearchResults);
  paginationView.addHandlerClick(controlPagination);
  addRecipeView.addHandlerUpload(controlAddRecipe);
};
init();
